import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { LayerApi } from '../../../api/layer-api';
import { UserApi } from '../../../api/user-api';
import { environment } from '../../../environment';
import { InputConverter } from '../../../inputConverter';
import { LayerService } from '../../../services/layer.service';
import { BaseComponent } from '../../base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-share-layer',
    styleUrls: ['../../sharedStyles/base.scss', '../../sharedStyles/telerik.scss', './share-layer.component.scss'],
    templateUrl: './share-layer.component.html'
})
export class ShareLayerComponent extends BaseComponent {
    _layerId: number;
    @Input()
    @InputConverter()
    get layerId() { return this._layerId; }
    set layerId(value: number) {
        this._layerId = value;
        if (this._layerId) {
            //make api call to get layer's currently linked users
            this.loading = true;
            this.getUserLayers();
        }
    }

    userIdsLayerIsSharedWith: number[] = [];
    loading: boolean = false;

    @Input()
    @InputConverter()
    includeEmail: boolean;
    @Input() userIds: number[] = [];
    mapcoreUsers: any[] = [];
    @Input() recipients: any[] = [];
    @Input() alreadySharedNames: string[] = [];
    outputSearchText = new Subject<string>();
    @Output() readonly onclose: EventEmitter<void> = new EventEmitter<void>();
    inputSearchText = '';
    sharingLayer = false;
    successMessage = false;
    failureMessage = false;
    emailText = '';

    constructor(_vcr: ViewContainerRef,
                private readonly layerService: LayerService,
                private readonly userApi: UserApi,
                private readonly layerApi: LayerApi,
                private readonly cdr: ChangeDetectorRef) {
        super(_vcr, true);
        this.registerEvent('onclose', this.onclose);
        const milliseconds = 500;
        this.outputSearchText
            .pipe(debounceTime(milliseconds))
            .subscribe(searchText => {
                if (searchText.length !== 0) {
                    this.getUserSearch(searchText);
                } else {
                    this.mapcoreUsers = [];
                }
            });
    }

    async getUserSearch(searchText: string) {
        const results = await this.userApi.searchUsers(searchText);
        //don't show users that are already added as recipients && users that already have the map shared with them
        this.mapcoreUsers = results.filter(user => !this.userIds.includes(user.id) && !this.userIdsLayerIsSharedWith.includes(user.id));

        this.alreadySharedNames = [];
        for (const user of results) {
            if (this.userIdsLayerIsSharedWith.includes(user.id)) {
                this.alreadySharedNames.push(user.email);
            }
        }
        this.cdr.detectChanges();
    }

    selectUser(index: number) {
        this.recipients.push(this.mapcoreUsers[index]);
        this.userIds.push(this.mapcoreUsers[index].id);
        this.inputSearchText = '';
        this.mapcoreUsers = [];
    }

    async shareLayer() {
        const milliseconds = 3000;
        this.sharingLayer = true;
        try {
            const layers = await this.layerApi.getLayers([this.layerId], 'name');
            await this.layerApi.shareLayer(this.userIds, this.layerId).then(result => {
                if (result) {

                    this.sharingLayer = false;
                    this.successMessage = true;
                    if (this.includeEmail) {
                        // TODO: send selected users an email. Messsage text and email addresses are already available.

                        const emailAddresses: string[] = this.recipients.map(x => x.email);
                        const emailSubject = environment.appName + ': New Shared Layer';
                        const layerName = layers[0].name;

                        this.layerService.emailAboutSharedLayer(this.layerId, layerName, emailAddresses, emailSubject, this.emailText);
                    }
                    setTimeout(() => {
                        this.successMessage = false;
                        this.resetAndClose();
                    },         milliseconds);
                } else {
                    this.sharingLayer = false;
                    this.failureMessage = true;
                    setTimeout(() => {
                        this.failureMessage = false;
                    },         milliseconds);
                }
            });
        } catch (error) {
            this.sharingLayer = false;
            this.failureMessage = true;
            setTimeout(() => {
                this.failureMessage = false;
            },         milliseconds);
        }
    }

    removeRecipient(index: number) {
        this.recipients.splice(index, 1);
        this.userIds.splice(index, 1);
    }

    resetAndClose() {
        this.mapcoreUsers = [];
        this.userIds = [];
        this.inputSearchText = '';
        this.recipients = [];
        this.emailText = '';
        this.alreadySharedNames = [];
        this.onclose.emit();
    }

    getUserLayers(): void {
        this.userIdsLayerIsSharedWith = [];
        this.layerApi.getUserLayers(this._layerId).then(data => {
            for (const userLayer of data[0].userLayers) {
                if (userLayer.accessLevel !== 'OWNER') {
                    this.userIdsLayerIsSharedWith.push(userLayer.userId);
                }
            }
            this.loading = false;
            this.cdr.detectChanges();
        });
    }
}
